export const DialogButton = {
    OK: 'OK',
    YES_NO: 'YES_NO',
    OK_CANCEL: 'OK_CANCEL'

};

export const DialogButtonAnswer = {
    OK: 'OK',
    YES: 'YES',
    NO: 'NO',
    CANCEL: 'CANCEL'
};

export const ToastType = {
    INFO: 'Info',
    WARNING: "Warning",
    ERROR: "Error",
    SUCCESS: "Success",
    //CUSTOM: "Custom"
};

export const ButtonType = {
    NORMAL: 'normal',
    SUCCESS: 'success',
    DANGER: 'danger',
    DEFAULT: 'default'
}
